import {
  SpotlightFormSchema,
  SpotlightTriggerType,
} from "@redotech/redo-model/spotlight-schema";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getSpotlight = {
  name: "getSpotlight" as const,
  input: z.object({
    shopifyCustomerId: z.string().nullable(),
    customerHash: z.string(),
    isOnMobile: z.boolean(),
    currentUrl: z.string(),
    forceId: z.string().optional(),
    triggerType: createEnum(SpotlightTriggerType).optional(),
  }),
  output: z.object({
    spotlight: SpotlightFormSchema.nullable(),
    spotlightId: z.string().nullable(),
    treatmentId: z.string().nullable(),
    merchantPhoneNumber: z.string().optional(),
    reason: z.string().optional(),
  }),
};
